<div class="table-row" [class.expanded]="isExpanded">
  <div class="row-main" (click)="toggleExpand.emit()" [class.with-checkbox]="selectable">
    <div class="cell checkbox-cell" *ngIf="selectable" (click)="$event.stopPropagation()">
      <mat-checkbox (change)="onSelectOrder($event)"></mat-checkbox>
    </div>
    <div class="cell order-id-cell">
      <span class="order-id-text">{{ order.orderId }}</span>
    </div>
    <div class="cell consignee-cell">
      <span class="consignee-text">{{ order.consigneeName }}</span>
    </div>
    <div class="cell volume-cell">
      <span class="volume-text">{{ order.totalCBM | number: '1.1-1' }} CBM</span>
    </div>
    <div class="cell weight-cell">
      <span class="weight-text">{{ order.totalWeight | number: '1.1-1' }}kg</span>
    </div>
    <div class="cell actions-cell" (click)="$event.stopPropagation()">
      <button 
        class="expand-btn"
        [class.expanded]="isExpanded"
        (click)="onToggleExpand($event)">
        <img src="assets/icons/down-arrow.svg" alt="Expand" class="arrow-icon">
      </button>
      <button 
        *ngIf="deletable" 
        class="delete-btn"
        (click)="onDeleteOrder($event)">
        <img src="assets/icons/job-planning/delete-order.png" alt="Delete" class="delete-icon">
      </button>
    </div>
  </div>

  <!-- Expandable Detail Section -->
  <div class="row-details" *ngIf="isExpanded">
    <div class="details-header">
      <div class="detail-item">
        <span class="detail-label">Planned Pickup:</span>
        <span class="detail-value">{{ order.pickupTime | date: 'M/d/yyyy, h:mm a' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">Planned Delivery:</span>
        <span class="detail-value">{{ order.deliveryEndDateTime | date: 'M/d/yyyy, h:mm a' }}</span>
      </div>
    </div>

    <div class="details-body">
      <div class="detail-row order-items-header">
        <span class="detail-label">Order Items</span>
        
        <div class="additional-info-inline">
          <div class="info-item">
            <span class="info-label">Priority</span>
            <span class="priority-badge" [class]="'priority-' + (order.priority?.toLowerCase() || 'low')">
              {{ order.priority || 'Low' }}
            </span>
          </div>
          <div class="info-item">
            <span class="info-label">Source</span>
            <span class="info-value source-badge">Source 1</span>
          </div>
          <div class="info-item">
            <span class="info-label">Remaining Time</span>
            <span class="info-value remaining-time">{{ calculateRemainingTime(order.deliveryEndDateTime) }}</span>
          </div>
        </div>
      </div>

      <div class="detail-row">
        <div class="order-items-section">
          <hmt-order-list [orders]="order.shipmentOrders || []"></hmt-order-list>
        </div>
      </div>

      <!-- <div class="detail-row location-info">
        <div class="location-group">
          <div class="location-item">
            <span class="location-label">Pickup Location</span>
            <span class="location-value">{{ order.pickupLocationName || order.pickupLocationShortName }}</span>
          </div>
          <mat-icon class="arrow-icon">arrow_forward</mat-icon>
          <div class="location-item">
            <span class="location-label">Delivery Location</span>
            <span class="location-value">{{ order.dropOffLocationName || order.dropOffLocationShortName }}</span>
          </div>
        </div>
      </div> -->

      <!-- <div class="detail-row time-windows">
        <div class="time-window-item">
          <span class="tw-label">Pickup Time Window</span>
          <span class="tw-value">{{ order.pickupTimeWindow }} min</span>
        </div>
        <div class="time-window-item">
          <span class="tw-label">Delivery Time Window</span>
          <span class="tw-value">{{ order.deliveryTimeWindow }} min</span>
        </div>
      </div> -->

      <!-- <div class="detail-row partial-shipment" *ngIf="order.partialShipmentAllowed !== undefined">
        <span class="ps-label">Partial Shipment:</span>
        <span class="ps-value" [class.allowed]="order.partialShipmentAllowed">
          {{ order.partialShipmentAllowed ? 'Allowed' : 'Not Allowed' }}
        </span>
      </div> -->
    </div>
  </div>
</div>

